import React from "react";

import FraudWidget from "@/components/widgets/FraudWidget";
import SideNavLayout from "@/layouts/SideNavLayout";
import BarDetailChart from "@/components/charts/BarDetailChart";

const AnalystDashboardPage = () => {
  return (
    <SideNavLayout>
      <div className="container-fluid">
        <div className="d-md-flex d-block align-items-center my-4 justify-content-between  page-header-breadcrumb">
          <div>
            <p className="fw-semibold fs-18 mb-0">Welcome back, Devery!</p>
            <span className="fs-semibold text-muted">
              Track your activity and get applicant updates here.
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col col-8"></div>
          <div className="col">
            <FraudWidget />
            <BarDetailChart />
          </div>
        </div>
      </div>
    </SideNavLayout>
  );
};

AnalystDashboardPage.propTypes = {};

export default AnalystDashboardPage;
